module.exports = __webpack_public_path__ + "img/classic_shop_thumbnail-600x450.ae1bacad.jpg";